import { Component, OnInit } from '@angular/core';
import { Item } from '../../models/item';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemService } from '../../services/item.service';
import { Location } from '@angular/common';
import { FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { ItemTypeService } from '../../services/item-type.service';
import { ItemType } from '../../models/item-type';
import { UserService } from '../../../../services/user.service';
import { UserDto } from '../../../../models/user.model';
import { compareEnums } from '../../../../base/functions/compare-functions';
import { DateValidators } from '../../../../validators/date-validators';
import { TranslateService } from '@ngx-translate/core';
import { SubmitExceptions } from '../../../../interfaces/iedit-form';
import { DisplayException } from '../../../../models/display-exception';

@Component({
  selector: 'app-item-edit',
  templateUrl: './item-edit.component.html',
  styleUrls: ['./item-edit.component.css']
})
export class ItemEditComponent  extends EditForm<Item> implements SubmitExceptions, OnInit {

  public typeFilter: FormControl = new FormControl();
  public compareFn = compareEnums;

  constructor(
    ns: ToastrService,
    tr: TranslateService,
    r: Router,
    ds: ItemService,
    ar: ActivatedRoute,
    l: Location,
    private itemTypeService: ItemTypeService,
    private userService: UserService
  ) {
    super(ns, tr, r, ds, ar, l, '/timeTracking/items');
  }

  itemTypes: ItemType[];
  users: UserDto[];
  public from = new FormControl(new Date());
  public till = new FormControl(new Date());

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      idState: new FormControl(),
      idItemType: new FormControl(),
      type: new FormControl(),
      idAccount: new FormControl(),
      idLocation: new FormControl(),
      idUser: new FormControl(),
      from: this.from,
      till: this.till,
      duration: new FormControl(),
    },
    DateValidators.dateLessThan('from', 'till', { 'till': true })
    );
    super.ngOnInit();
    this.itemTypeService.GetAll().subscribe((data) => {
      this.itemTypes = data.payload;
    });
    this.userService.getMembers().subscribe((data) => {
      this.users = data;
      this.form.controls['idUser'].setValue(this.userService.current.id);
    });
  }
  onStartDateChange(date: Date) {
  }
  onEndDateChange(date: Date)  {
  }
  onTest() {
  }
  getFormValidationErrors() {
    Object.keys(this.form.controls).forEach(key => {

    const controlErrors: ValidationErrors = this.form.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          });
        }
      });
  }
  onSubmitExceptions(response: DisplayException): void {
    if (response) {
        const error = `timeTracking.errors.${response.Type}`;
        this.translate.get(error).subscribe(msg => {
            this.notificationsService.error(response.Message, msg);
        });
    }
  }
}
